import { IAuthSessionContext } from '../types/authSession';

// Default data for init of context
const authContextDefault: IAuthSessionContext = {
  isAuthenticating: true,
  isAuthenticated: false,
  isAuthError: false,
  authToken: null,
  idToken: null,
  isUserIdleLogout: false,
  idTokenObj: null,
  legacyToken: null,
  showIdlePrompt: false,
  signOut: () => Promise.resolve(),
  resetIdlePrompt: () => {
    // do nothing.
  },
};

export default authContextDefault;
